// extracted by mini-css-extract-plugin
export default {"root":"SeedPhraseButtonWin98_root__raROR"};